<template>
  <h1 class="t t-lg bold m-b8">Add company values to Shoutouts</h1>
  <p class="t dark-gray">
    Employees can tag their Shoutouts with company values to highlight what
    matters most. You'll be able to see which values are celebrated most often
    and who's recognized for living them in the leaderboard.
  </p>

  <ul class="f f-v f-gap-12 m-tx2">
    <li class="m-t0">
      <span class="t dark-gray">Values can be tagged using the #valuetag</span>
      <points-slack-previews-channel-shoutout-message :hashtag="hashtag" :reacji-list="[]" class="m-t4" />
    </li>
    <li class="m-t0">
      <span class="t dark-gray">Using the value emoji</span>
      <points-slack-previews-channel-shoutout-message :emoji="emoji" :reacji-list="[]" class="m-t4" />
    </li>
    <li class="m-t0">
      <span class="t dark-gray">Using the value emoji as a reaction</span>
      <points-slack-previews-channel-shoutout-message :reacji-list="[{ emoji, count: 6 }]" class="m-t4" />
    </li>
  </ul>
  <p v-emoji="valuePointsCopy" class="t m-tx3" />
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useSharedState } from './module';

const { getters } = useStore();
const { tags } = useSharedState();
const emoji = computed(() => tags.value?.[0]?.emoji || 'fast_forward');
const hashtag = computed(() => tags.value?.[0]?.hashtag || 'movefast');

const valuePointsCopy = computed(() => {
  const pointsLabel = getters['pointsConfig/pointsPhraseFromConfig']({ points: 1, hideNumber: true });
  return `A value emoji is worth the same as a ${pointsLabel} in a message or as a reaction. `
      + `A #valuetag doesn't add additional points unless the message has no ${pointsLabel} or value emoji in it.`;
});
</script>
